import BreadcrumbsComponent from '../components/Breadcrumbs/viewer/Breadcrumbs';
import BreadcrumbsController from '../components/Breadcrumbs/viewer/Breadcrumbs.controller';


const Breadcrumbs = {
  component: BreadcrumbsComponent,
  controller: BreadcrumbsController
};


export const components = {
  ['Breadcrumbs']: Breadcrumbs
};


// temporary export
export const version = "1.0.0"
